import Actions from '../constants/Actions';
import {getFavorites} from './CommonActionCreators';

export async function checkAuthenticated(context) {
  console.log('Checking authentication');
  context.dispatch(Actions.AUTHENTICATION_CHECK_STARTED);
  const result = await context.service.read('authentication', {});
  console.log('Authentication check complete', result.data);
  context.dispatch(Actions.AUTHENTICATION_CHECK_COMPLETED, result.data);

  return result.data;
}

export async function lookupActivationKey(context, {activationKey}) {
  try {
    const result = await context.service.read('password', {
      activationKey: activationKey
    });
    context.dispatch(Actions.ACTIVATION_KEY_FOUND, result.data);

    return result.data;
  } catch (err) {
    console.log('Unable to find user for activationKey', activationKey);
    throw err;
  }
}

export async function updateAuthenticationCredentials(context, payload) {
  context.dispatch(Actions.AUTHENTICATION_CLEAR_FORM_STATE, payload);
}

export async function forgotPassword(context, {emailAddress} = {}) {
  if (emailAddress) {
    try {
      context.dispatch(Actions.PASSWORD_FORGOT_STARTED);
      await context.service.delete('password', {
        emailAddress
      });

      context.dispatch(Actions.PASSWORD_FORGOT_COMPLETE);
    } catch (err) {
      context.dispatch(Actions.PASSWORD_FORGOT_FAILED);
    }
  }
}

export function updateResetPasswordFormState(context, formState) {
  context.dispatch(Actions.PASSWORD_RESET_FORM_STATE_CHANGED, formState);
}

export async function processPasswordReset(context, {password}) {
  try {
    context.dispatch(Actions.PASSWORD_RESET_STARTED);
    const ResetPasswordStore = context.getStore('ResetPasswordStore');
    const payload = {
      activationKey: ResetPasswordStore.getActivationKey(),
      password
    };
    await context.service.create('password', {}, payload);
    context.dispatch(Actions.PASSWORD_RESET_COMPLETE);
  } catch (err) {
    console.log('Error processing password reset', err);
    context.dispatch(Actions.PASSWORD_RESET_FAILED);

    throw err;
  }
}

export async function login(context, {redirect, emailAddress, password, rememberMe}) {
  context.dispatch(Actions.AUTHENTICATION_STARTED);
  const credentials = {
    emailAddress,
    password,
    rememberMe
  };


  try {
    const result = await context.service.create('authentication', {}, credentials);

    console.log('Authentication completed, dispatching event');
    if (result.data.authenticated) {
      await context.executeAction(getFavorites);
      context.dispatch(Actions.AUTHENTICATION_COMPLETED, result.data);
      console.log('Authentication event processing complete');
      const router = context.getRouter();
      if (redirect) {
        router.push(redirect);
      } else {
        router.push('/');
      }
    } else {
      context.dispatch(Actions.AUTHENTICATION_FAILED);
    }
  } catch (e) {
    console.log(e);
    context.dispatch(Actions.AUTHENTICATION_FAILED);
  }
}

export async function logout(context) {
  context.dispatch(Actions.AUTHENTICATION_LOGGING_OUT_STARTED);
  const result = await context.service.delete('authentication', {});
  context.dispatch(Actions.AUTHENTICATION_LOGGING_OUT_COMPLETED, result.data);
}

export async function authorize(context, {credentials}) {
  context.dispatch(Actions.AUTHENTICATION_AUTHORIZATION_STARTED);
  const result = await context.service.update('authentication', credentials);
  context.dispatch(Actions.AUTHENTICATION_AUTHORIZATION_COMPLETED, result.data);
}

export async function signUp(context, bank) {
  console.log('Signing up', {bank});
  context.dispatch(Actions.SIGN_UP_PROCESSING);
  const {data: {success}} = await context.service.create('account', {bank});

  context.dispatch(Actions.SIGN_UP_COMPLETE, {success});
}



// WEBPACK FOOTER //
// ./src/actions/AuthenticationActionCreators.js